import { Flex, Image } from "@chakra-ui/react";
import loginLeftIcon from "assets/login-left-icon.svg"
import loginRightIcon from "assets/login-right-icon.svg"
export function PublicBlobs() {
  return (
    <Flex
      pos={"absolute"}
      w={"100vw"}
      h={"100vh"}
      left={0}
      right={0}
      bottom={0}
      top={0}
      overflow={"hidden"}
      align={"center"}
      justify={"center"}
      zIndex={-1}
      userSelect={"none"}
    >
     <Image
      src={loginLeftIcon}
      position="absolute"
      top="0"
      left="0"
      zIndex={-2}
    />
    <Image
      src={loginRightIcon}
      position="absolute"
      bottom="0"
      right="0"
      zIndex={-2}
    />
    </Flex>
  );
}
